import moment from 'moment';
import React from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import p_active from '../../assets/maintain_bookings_screen/p_active.png';
import p_inactive from '../../assets/maintain_bookings_screen/p_inactive.png';
import { DATE_FORMAT } from '../../constants/format';
import { openBookingDetailsModal } from '../../modals/BookingDetailsModal';
import { is_booking_canceled } from './bookingUtils';

const i18nPrefix = 'MaintainBookings';

const dateFormatted = (booking) => {
  const from =
    booking.from_date && moment(booking.from_date).format(DATE_FORMAT);
  const to = booking.to_date && moment(booking.to_date).format(DATE_FORMAT);
  return `${from} - ${to}`;
};

const BookingItem = ({ booking }) => {
  const { t } = useTranslation();

  const canceled = is_booking_canceled(booking);
  const show_payment_state = !canceled && !Number(booking.payment_status);
  const show_confirmation_state = !canceled && !Number(booking.confirmed);

  return (
    <div
      className='bookings__item'>
      <div className='bookings__item-row'>
        <img
          src={canceled ? p_inactive : p_active}
          alt={t(`${i18nPrefix}.bookingIcon`, 'Booking icon')}
          className='bookings__item-icon'
        />
        <div
          style={{
            display: 'grid',
            gap: 6,
            flex: 1,
            minWidth: 0,
          }}>
          <div style={{ fontWeight: 700 }}>{booking.reservation_name}</div>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            {!Number(booking.payment_status) && (
              <span style={{ color: '#d32f2f', fontWeight: 600 }}>
                {t(`${i18nPrefix}.unpaid`, 'Unpaid')}
                {!Number(booking.confirmed) && ' / '}
              </span>
            )}
            {!Number(booking.confirmed) && (
              <span style={{ color: '#d32f2f', fontWeight: 600 }}>
                {t(`${i18nPrefix}.unconfirmed`, 'Unconfirmed')}
              </span>
            )}
          </div>
          <div style={{ fontWeight: 600 }}>{dateFormatted(booking)}</div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 12,
              flexWrap: 'wrap',
            }}>
            <div>
              <div style={{ fontSize: 12, opacity: 0.7 }}>
                {t(`${i18nPrefix}.totalPrice`, 'Total price')}
              </div>
              <div style={{ fontWeight: 700 }}>
                {booking.currency} {booking.total_price}
              </div>
            </div>
            <Button
              type='button'
              variant='outline-primary'
              size='sm'
              onClick={() =>
                openBookingDetailsModal({ bookingId: booking.booking_id })
              }>
              {t(`${i18nPrefix}.details`, 'Details')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingItem;
